<div class="order-history-container">
  <!-- Page Header -->
  <div class="page-header">
   
    <h1 class="page-title">
      <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="title-icon">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
      </svg>
      {{ t('orderHistory') }}
    </h1>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>{{ t('loadingOrders') }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <div class="error-message">
      <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      {{ t('errorLoadingOrders') }}
    </div>
    <button class="retry-btn" (click)="retry()">
      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
      </svg>
      {{ t('retry') }}
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !error && orders.length === 0" class="empty-container">
    <div class="empty-icon">
      <svg width="64" height="64" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
      </svg>
    </div>
    <h3>{{ t('noOrdersYet') }}</h3>
    <p>{{ t('noOrdersDescription') }}</p>
    <button class="shop-now-btn" (click)="goBack()">
      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
      </svg>
      {{ t('startShopping') }}
    </button>
  </div>

  <!-- Orders List -->
  <div *ngIf="!loading && !error && orders.length > 0" class="orders-container">
    <div class="orders-header">
      <div class="header-content">
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="header-icon">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
        </svg>
        <h2>{{ t('yourOrders') }}</h2>
      </div>
      <p>{{ orders.length }} {{ orders.length === 1 ? t('order') : t('orders') }}</p>
    </div>

    <div class="orders-list">
      <div *ngFor="let order of orders" class="order-card" [ngStyle]="getOrderLightBgColor(order)">
        <!-- Order Header Row -->
        <div class="order-header-row">
          <div class="order-id-status">
            <span class="order-id">#{{ order.id }}</span>
            <span class="order-date">{{ formatDate(order.orderDate) }}</span>
            @if (order.isOfflinePurchase) {
              <span class="offline-tag">{{ t('offlinePurchaseTag') }}</span>
            }
          </div>
          <div class="status-badge" [class]="getStatusClass(order.status)">
            <span class="status-text">{{ getStatusText(order.status) }}</span>
            @if (order.status === 'shipped' && order.shippingDate) {
              <span class="status-date">{{ formatDateTime(order.shippingDate) }}</span>
            }
            @if (order.status === 'delivered' && order.deliveredDate) {
              <span class="status-date">{{ formatDateTime(order.deliveredDate) }}</span>
            }
          </div>
        </div>

        <!-- 3 Column Layout -->
        <div class="order-content-grid">
          <!-- Column 1: Product Details with Image -->
          <div class="order-column product-column">
            <h4 class="column-title">
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
              </svg>
              Products
            </h4>
            <div class="products-list">
              <div *ngFor="let product of order.products" class="product-item">
                <img 
                  [src]="getProductImage(product)" 
                  [alt]="productLocalizationService.getLocalizedName(product)"
                  class="product-image"
                  (error)="handleImageError($event)"
                  loading="lazy">
                <div class="product-details">
                  <p class="product-name">{{ getDisplayNameWithCategory(product) }}</p>
                  <p class="product-description" *ngIf="productLocalizationService.getLocalizedDescription(product)">
                    {{ productLocalizationService.getLocalizedDescription(product) }}
                  </p>
                  <p class="sub-products" *ngIf="getSubProducts(product)">
                    <span class="sub-products-label">{{ t('itemsInBox') || 'Items in box' }}:</span>
                    <span class="sub-products-list">{{ getSubProducts(product) }}</span>
                  </p>
                  <!-- <p class="product-quantity">Qty: {{ product.cartQuantity || product.quantity || 1 }}</p> -->
                </div>
              </div>
            </div>
            
            <!-- Order Progress Timeline - Vertical -->
            <div class="order-progress-timeline">
              <div 
                *ngFor="let step of getOrderProgressSteps(order); let i = index; let isLast = last" 
                class="timeline-step"
                [class.completed]="step.completed"
                [class.active]="step.active">
                <div class="timeline-content">
                  <div class="timeline-dot"></div>
                  <div class="timeline-info">
                    <div class="timeline-label">{{ step.label }}</div>
                    <div *ngIf="step.dateTime" class="timeline-date">{{ step.dateTime }}</div>
                  </div>
                </div>
                <div *ngIf="!isLast" class="timeline-line"></div>
              </div>
            </div>
          </div>

          <!-- Column 2: Payment & Order Info -->
          <div class="order-column summary-column">
            <h4 class="column-title">
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
              Payment & Order Info
            </h4>
            <div class="summary-content">
              <!-- Amount Breakdown - 3 Blocks in a Row -->
              <div class="amount-breakdown">
                <div class="amount-block">
                  <div class="amount-icon">
                    <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                    </svg>
                  </div>
                  <div class="amount-content">
                    <label>Product Amount</label>
                    <span class="amount-value">₹{{ getProductAmount(order).toFixed(2) }}</span>
                  </div>
                </div>
                <div class="amount-block">
                  <div class="amount-icon">
                    <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
                    </svg>
                  </div>
                  <div class="amount-content">
                    <label>Delivery Charges</label>
                    <span class="amount-value">₹{{ getDeliveryCharges(order).toFixed(2) }}</span>
                  </div>
                </div>
                <div class="amount-block grand-total-block">
                  <div class="amount-icon">
                    <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                  </div>
                  <div class="amount-content">
                    <label>Grand Total</label>
                    <span class="amount-value grand-total">₹{{ getGrandTotal(order).toFixed(2) }}</span>
                  </div>
                </div>
              </div>
              
              <div *ngIf="order.discountAmount && order.discountAmount > 0" class="summary-row discount">
                <span class="summary-label">Discount:</span>
                <span class="summary-value">-₹{{ order.discountAmount.toFixed(2) }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">Payment Method:</span>
                <span class="summary-value payment-method">{{ order.paymentMethod }}</span>
              </div>
              <div class="summary-row">
                <span class="summary-label">Payment Status:</span>
                <span class="summary-value payment-status" [class]="getPaymentStatusClass(order.paymentStatus)">
                  {{ getPaymentStatusText(order.paymentStatus) }}
                </span>
              </div>
              <!-- Track Shipping Button -->
              <div *ngIf="canTrackOrder(order)" class="track-shipping-section">
                <button 
                  class="track-shipping-btn" 
                  (click)="trackOrder(order)"
                  [disabled]="trackingLoading[order.id]">
                  <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" class="track-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <span *ngIf="!trackingLoading[order.id]">Track Order</span>
                  <span *ngIf="trackingLoading[order.id]">Loading...</span>
                </button>
                <p *ngIf="getTrackingNumber(order)" class="tracking-number">
                  Tracking: {{ getTrackingNumber(order) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Column 3: Delivery Address -->
          <div class="order-column address-column">
              <h4 class="column-title">
                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                Delivery Address
              </h4>
              <div class="address-content">
                <div class="address-field">
                  <span class="address-label">Name:</span>
                  <span class="address-value">{{ parseDeliveryAddress(order.deliveryAddress).name }}</span>
                </div>
                <div class="address-field">
                  <span class="address-label">Address:</span>
                  <span class="address-value">{{ parseDeliveryAddress(order.deliveryAddress).address }}</span>
                </div>
                <div class="address-field">
                  <span class="address-label">Mobile:</span>
                  <span class="address-value">{{ parseDeliveryAddress(order.deliveryAddress).mobile }}</span>
                </div>
              </div>
              <div *ngIf="order.status === 'delivered'" class="delivered-date">
                <span class="label">Delivered:</span>
                <span>{{ formatDate(order.deliveredDate) || 'N/A' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Tracking Modal -->
  <div *ngIf="showTrackingModal && selectedOrderForTracking" class="tracking-modal-overlay" (click)="closeTrackingModal()">
    <div class="tracking-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Track Your Order</h3>
        <button class="close-btn" (click)="closeTrackingModal()">
          <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      
      <div class="modal-body">
        <div *ngIf="trackingData[selectedOrderForTracking.id]" class="tracking-info">
          <div class="tracking-header">
            <div class="tracking-number-display">
              <span class="label">Tracking Number:</span>
              <span class="value">{{ getTrackingNumber(selectedOrderForTracking) }}</span>
            </div>
            <div class="tracking-status" [class]="'status-' + (getTrackingStatus(selectedOrderForTracking).toLowerCase() || 'transit')">
              {{ getTrackingStatus(selectedOrderForTracking) }}
            </div>
          </div>

          <div *ngIf="selectedOrderForTracking.shiprocketCourierName" class="courier-info">
            <span class="label">Courier:</span>
            <span class="value">{{ selectedOrderForTracking.shiprocketCourierName }}</span>
          </div>

          <div *ngIf="trackingData[selectedOrderForTracking.id].etd" class="estimated-delivery">
            <span class="label">Estimated Delivery:</span>
            <span class="value">{{ formatTrackingDate(trackingData[selectedOrderForTracking.id].etd) }}</span>
          </div>

          <div *ngIf="trackingData[selectedOrderForTracking.id].tracking_events && trackingData[selectedOrderForTracking.id].tracking_events.length > 0" class="tracking-events">
            <h4>Tracking History</h4>
            <div class="events-timeline">
              <div *ngFor="let event of trackingData[selectedOrderForTracking.id].tracking_events" class="event-item">
                <div class="event-dot"></div>
                <div class="event-content">
                  <div class="event-status">{{ event.status }}</div>
                  <div class="event-location">{{ event.location }}</div>
                  <div class="event-date">{{ formatTrackingDate(event.scan_date_time) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!trackingData[selectedOrderForTracking.id].tracking_events || trackingData[selectedOrderForTracking.id].tracking_events.length === 0" class="no-events">
            <p>No tracking events available yet. Please check back later.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 